import { lazyInitMailSignatureCloudSettings } from 'mini-mail-signature-cloud-settings';
import { storeEmailSignaturePreferenceInCache } from 'mini-mail-signature';
import {
    EmailSignaturePreference,
    fetchUserEmailSignaturePreference,
} from 'mini-bx-user-custom-properties';

/**
 * Fetch the email signature preference from server and cache it in UI.
 */
export async function loadEmailSignaturePreferences(): Promise<EmailSignaturePreference> {
    // Fetch user's email signature preferences from SDS
    const emailSignaturePreference = await fetchUserEmailSignaturePreference();

    // Cache the email preferences we got from server
    storeEmailSignaturePreferenceInCache(emailSignaturePreference);

    if (emailSignaturePreference?.UseDesktopSignature) {
        // Load big OWA's signature setting to MailSignatureCloudSettings store
        lazyInitMailSignatureCloudSettings.importAndExecute();
    }
    return emailSignaturePreference;
}
